"use client";

import { createContext, useContext } from "react";

const MatchInfoContext = createContext(null);

export function MatchInfoProvider({ children, value }) {
  return (
    <MatchInfoContext.Provider value={value}>
      {children}
    </MatchInfoContext.Provider>
  );
}

export function useMatchInfo() {
  const context = useContext(MatchInfoContext);
  if (!context) {
    throw new Error("useMatchInfo must be used within MatchInfoProvider");
  }
  return context;
}
